import React, { createContext, useContext } from "react"

type ProductTableProviderContextType = {
  searchText?: string
  onRowClicked?: (data: any) => void
  warehouseId?: string
  startDate?: Date
  endDate?: Date
  onApplySuggestedOrders?: (variantIds: string[]) => void
}

const ProductTableContext = createContext<ProductTableProviderContextType | undefined>(undefined)

export const ProductTableProvider = ({
  children,
  value,
}: {
  children: React.ReactNode
  value?: ProductTableProviderContextType
}) => {
  return <ProductTableContext.Provider value={value}>{children}</ProductTableContext.Provider>
}

export const useProductTableContext = () => {
  const context = useContext(ProductTableContext)
  if (!context) {
    throw new Error("useProductTableContext must be used within a ProductTableProvider")
  }
  return context
}
